export const BOTTOM_NAV_HEIGHT = 72
const SAFE_AREA_INSET_BOTTOM = 'env(safe-area-inset-bottom, 0px)'

const normalizeBaseValue = (baseValue: string | number) => {
  if (typeof baseValue === 'number') {
    return `${baseValue}px`
  }

  return baseValue
}

export const getFloatingBottomOffset = (baseValue: string | number) => {
  return `calc(${normalizeBaseValue(baseValue)} + ${BOTTOM_NAV_HEIGHT}px + ${SAFE_AREA_INSET_BOTTOM})`
}

